import type { GetProductsResponse } from '@dtp/membership-service-types';
import { Action, ActionType } from 'typesafe-actions';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import { ofType } from 'redux-observable';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { Actions, actions } from '@redux/modules/internationalDrivingPermit';
import { TypedEpic } from './types';

export const getInternationDrivingPermitEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_INTERNATIONAL_DRIVING_PERMIT),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getInternationalDrivingPermit.request>[]
    >,
    switchMap(([action]) => {
      const params = action.payload ? { campaignCode: action.payload } : undefined;

      return fromApiRequest((signal) =>
        apiClient.get<GetProductsResponse>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].v2.products,
          params,
        }),
      ).pipe(
        map((response) => actions.getInternationalDrivingPermit.success(response.data)),
        catchError((err) =>
          of(actions.getInternationalDrivingPermit.failure(toReduxError(err, GENERIC_FETCH_ERROR_MESSAGE))),
        ),
      );
    }),
  );

export const epics: TypedEpic[] = [getInternationDrivingPermitEpic];
